export const environment = {
    production: true,
    apiBaseURL:'/api',
    siteBaseURL:"",
    localMode:false,
    siteName:'MH-RE-DSM',
    googleMapsKey:'AIzaSyCrDki6OXFH0pHcnv2f68_hOTZ-z7loU9E',


  };